import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface RefreshIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const RefreshIcon = ({ className, ...props }: RefreshIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.9106 13.2C19.3316 17.049 16.0104 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C15.2805 4 18.0998 5.97455 19.3343 8.8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
    <path
      d="M16 8.80005H19.52C19.7851 8.80005 20 8.58515 20 8.32005V4.80005"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
  </svg>
);

export default RefreshIcon;
